import { render, staticRenderFns } from "./deformation.vue?vue&type=template&id=30e9a1fa&scoped=true"
import script from "./deformation.vue?vue&type=script&lang=js"
export * from "./deformation.vue?vue&type=script&lang=js"
import style0 from "./deformation.vue?vue&type=style&index=0&id=30e9a1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9a1fa",
  null
  
)

export default component.exports